import React from "react";
import { useQuery } from "react-query";
import { ExportJob, Report, ReportObject } from "types";
import { api } from "../../../api/api";
import { getQueryParams } from "../../../models/ReportFilterState";
import { ExportJobModal } from "../../Common/ExportJobModal";
import { ReportFilterState } from "./ReportFilterState";
import { redemptionAppApi } from "@/api/redemptionAppApi";

interface CustomReportExportModalProps {
    isOpen: boolean;
    onClose: () => void;
    report: Report;
    filter: ReportFilterState;
    excludedColumns: string[];
}

export const CustomReportExportModal = ({
    isOpen,
    onClose,
    report,
    filter,
    excludedColumns,
}: CustomReportExportModalProps) => {
    return isOpen ? (
        <ModalContent
            isOpen={isOpen}
            report={report}
            filter={filter}
            excludedColumns={excludedColumns}
            onClose={onClose}
        />
    ) : null;
};

const ModalContent = ({ isOpen, onClose, report, filter, excludedColumns }: CustomReportExportModalProps) => {
    const filterParams = { ...getQueryParams(filter), format: "xlsx" };

    // since to render the Product column in the transactions report we should send the field name as "items.0.orderItem.product.id",
    // but to exclude this column in the exported file we should send "purchase.items.name", we need this condition here
    const isCustomTransactionsReport = report.object === ReportObject.TRANSACTIONS;
    const isReportExcluded = excludedColumns.includes("items.0.orderItem.product.id");
    const productField = isCustomTransactionsReport && isReportExcluded ? "purchase.items.name" : "";
    const isTicketRedemptionReport = report.object === ReportObject.TICKET_REDEMPTION;
    const apiClient = isTicketRedemptionReport ? redemptionAppApi : api;

    const excludedQueryParams =
        excludedColumns.length > 0
            ? [...excludedColumns, productField].filter((column) => column !== undefined).join(",")
            : null;

    const params = { ...filterParams, excludedColumns: excludedQueryParams };

    const { data: job } = useQuery<ExportJob>(
        [report.collection, "collection", params],
        async () => {
            const { data } = await apiClient.get<ExportJob>(`/${report.collection}`, { params });
            return data;
        },
        { enabled: isOpen },
    );

    return job ? (
        <ExportJobModal
            isOpen={isOpen}
            job={job}
            onClose={onClose}
            {...(isTicketRedemptionReport ? { apiClient } : {})}
        />
    ) : null;
};
